var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimflexityLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    viewBox: "0 0 291.52 75",
    width: 291.51999,
    height: 75,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs37"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style35"
  }, ".b{fill:#0f2a40;}.c{fill:#2c895a;}"))), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M 49.210885,26.810726 68.848427,26.95581 C 68.93377,16.10865 60.203129,7.2499937 49.355969,7.1731845 40.941099,7.1134441 33.729572,12.353536 30.879098,19.769886 l -0.01707,0.04267 c -0.05121,0.119481 -0.09388,0.247496 -0.13655,0.375511 -0.0085,0.03414 -0.0256,0.06827 -0.03414,0.102413 -0.03414,0.102412 -0.06827,0.204824 -0.102412,0.307236 -0.01707,0.05974 -0.03414,0.110947 -0.05974,0.170687 -0.0256,0.07681 -0.05121,0.162153 -0.07681,0.238962 -0.0256,0.07681 -0.05121,0.162153 -0.07681,0.238962 -0.01707,0.05974 -0.03414,0.110947 -0.05121,0.170687 -0.0256,0.102412 -0.05974,0.204824 -0.08534,0.315771 -0.0085,0.03414 -0.01707,0.06828 -0.0256,0.102412 -0.03414,0.128015 -0.06827,0.256031 -0.09388,0.384046 v 0.04267 c -1.84342,7.732122 1.152138,16.129924 8.124703,20.832351 l 10.97518,-16.283538 z",
    id: "path39",
    style: {
      strokeWidth: 0.853435
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m 41.000839,48.189276 -19.637542,0.136549 c 0.07681,10.847161 8.935466,19.577802 19.782626,19.500993 8.41487,-0.05974 15.549588,-5.402244 18.297649,-12.861267 l 0.01707,-0.04267 c 0.04267,-0.128015 0.08534,-0.247496 0.128015,-0.375512 0.0085,-0.03414 0.0256,-0.06827 0.03414,-0.102412 0.03414,-0.102412 0.06827,-0.204824 0.102413,-0.307237 0.01707,-0.05974 0.03414,-0.110946 0.05121,-0.170687 0.0256,-0.07681 0.05121,-0.162152 0.06827,-0.238961 0.0256,-0.07681 0.05121,-0.162153 0.06827,-0.238962 0.01707,-0.05974 0.03414,-0.119481 0.04267,-0.170687 0.0256,-0.102412 0.05974,-0.213359 0.08534,-0.315771 0.0085,-0.03414 0.01707,-0.06827 0.0256,-0.110947 0.03414,-0.128015 0.05974,-0.25603 0.09388,-0.384046 v -0.04267 C 61.892931,44.70726 58.777893,36.352131 51.737053,31.752115 L 41.000839,48.19781 Z",
    id: "path41",
    style: {
      strokeWidth: 0.853435
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g63",
    transform: "matrix(0.85343512,0,0,0.85343512,21.363297,7.1731845)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m 88.6,18.76 -3.29,6.49 c 0,0 -3.55,-2.46 -7.22,-2.46 -2.77,0 -4.24,1.25 -4.24,3.2 0,1.95 3.37,3.42 7.44,5.15 3.98,1.69 8.35,5.06 8.35,9.73 0,8.52 -6.49,11.5 -13.45,11.5 -8.35,0 -13.41,-4.71 -13.41,-4.71 l 4.06,-6.83 c 0,0 4.76,4.02 8.73,4.02 1.77,0 5.15,-0.17 5.15,-3.5 0,-2.59 -3.81,-3.76 -8.04,-5.88 -4.28,-2.12 -6.79,-5.45 -6.79,-9.17 0,-6.66 5.88,-10.9 11.63,-10.9 6.49,0 11.07,3.37 11.07,3.37 z",
    id: "path43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m 102.22,20.36 c 0,2.51 -2.03,4.54 -4.54,4.54 -2.51,0 -4.54,-2.03 -4.54,-4.54 0,-2.51 2.03,-4.54 4.54,-4.54 2.51,0 4.54,2.03 4.54,4.54 z m -8.48,31.35 h 7.65 V 29.53 h -7.65 z",
    id: "path45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m 107.11,29.53 h 7.65 v 2.34 h 0.09 c 1.73,-1.73 3.94,-2.98 6.36,-2.98 2.94,0 6.18,1.08 7.74,4.06 2.33,-2.81 4.93,-4.06 7.35,-4.06 4.06,0 8.65,2.03 8.65,8.22 V 51.73 H 137.3 V 39.19 c 0,-2.21 -1.17,-4.15 -3.89,-4.15 -2.42,0 -3.46,1.77 -3.55,3.46 v 13.23 h -7.65 V 39.19 c 0,-2.21 -1.17,-4.15 -3.89,-4.15 -2.55,0 -3.55,1.95 -3.55,3.72 v 12.97 h -7.65 v -22.2 z",
    id: "path47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m 151.31,24.82 c 0.04,-6.49 3.16,-10.94 8.69,-10.94 3.89,0 6.31,1.99 6.31,1.99 l -2.68,5.41 c 0,0 -1.04,-0.61 -2.29,-0.61 -1.95,0 -2.38,1.3 -2.38,4.37 v 4.5 h 5.1 v 5.84 h -5.1 v 16.35 h -7.65 V 35.38 h -3.2 v -5.84 h 3.2 v -4.71 z",
    id: "path49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m 167.01,14.53 h 7.65 v 37.19 h -7.65 z",
    id: "path51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m 186.51,41.68 c 0,3.42 2.85,4.58 4.8,4.58 2.46,0 3.55,-0.48 5.41,-2.46 l 5.54,2.77 c -2.51,4.19 -6.57,5.79 -11.5,5.79 -6.7,0 -12.2,-5.28 -12.2,-11.72 0,-6.44 5.49,-11.76 12.2,-11.76 6.71,0 11.89,3.98 11.89,11.76 0,0.3 0,0.78 -0.04,1.04 h -16.09 z m 8.65,-4.24 c -0.35,-2.33 -1.95,-3.59 -4.19,-3.59 -2.64,0 -4.11,1.56 -4.24,3.59 z",
    id: "path53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m 222.97,51.72 -4.89,-6.27 -4.89,6.27 h -9.25 l 9.47,-11.59 -8.13,-10.59 h 8.95 l 3.85,5.15 3.85,-5.15 h 8.95 l -8.13,10.59 9.47,11.59 z",
    id: "path55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m 243.6,20.36 c 0,2.51 -2.03,4.54 -4.54,4.54 -2.51,0 -4.54,-2.03 -4.54,-4.54 0,-2.51 2.03,-4.54 4.54,-4.54 2.51,0 4.54,2.03 4.54,4.54 z m -8.48,31.35 h 7.65 V 29.53 h -7.65 z",
    id: "path57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m 249.78,21.27 h 7.65 v 8.26 h 4.67 v 5.84 h -4.67 v 7.05 c 0,2.08 0.52,3.07 1.73,3.07 1,0 1.9,-0.69 1.9,-0.69 l 1.9,6.18 c 0,0 -2.46,1.38 -5.62,1.38 -6.1,0 -7.57,-4.54 -7.57,-8.48 v -8.52 h -3.2 v -5.84 h 3.2 v -8.26 z",
    id: "path59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m 291.52,29.53 -17.43,33.43 h -8.82 l 7.65,-14.7 -10.51,-18.72 h 8.82 l 6.18,11.37 5.28,-11.37 h 8.82 z",
    id: "path61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimflexityLogo);
export default __webpack_public_path__ + "static/media/simflexity-logo.f7c52ec6af3f250260178c8166f426a0.svg";
export { ForwardRef as ReactComponent };